import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'obfuscateMobileNumber',
})
export class ObfuscateMobileNumberPipe implements PipeTransform {
  transform(mobileNumber: string | null | undefined): string {
    if (!mobileNumber) return '';

    const cleaned = mobileNumber.replace(/[\s-]/g, '');

    // Find prefix (like +33 or 0)
    const prefixMatch = cleaned.match(/^(\+?\d{1,3}|0)/);
    const prefix = prefixMatch ? prefixMatch[0] : '';
    const rest = cleaned.slice(prefix.length);

    if (rest.length <= 4) {
      // too short, just mask middle digits if any
      return prefix + rest.replace(/.(?=..)/g, '*');
    }

    // Keep first 3 of rest and last 2 visible
    const visibleStart = rest.slice(0, 3);
    const visibleEnd = rest.slice(-2);
    const hidden = '*'.repeat(Math.max(rest.length - 5, 0));

    return `${prefix}${visibleStart}${hidden}${visibleEnd}`;
  }
}
